import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth/AuthContext.jsx'
import { LanguageSwitcher } from './LanguageSwitcher.jsx'
import { AnnouncementsBell } from './AnnouncementsBell.jsx'

export function Header() {
  const { t } = useTranslation()
  const { user, logout, loading } = useAuth()
  const navigate = useNavigate()

  const role = user?.role

  async function handleLogout() {
    await logout()
    navigate('/', { replace: true })
  }

  return (
    <header className="site-header">
      <div className="brand">
        <Link to="/"><strong>{t('common.app_name')}</strong></Link>
        <span className="tagline">{t('common.tagline')}</span>
      </div>

      <nav className="site-nav">
        <Link to="/courses">{t('nav.courses')}</Link>

        {!loading && !user && (
          <Link to="/login">{t('nav.login')}</Link>
        )}

        {!loading && user && (
          <>
            <Link to="/me/enrollments">{t('nav.enrollments')}</Link>
            <Link to="/settings/participants">{t('nav.participants')}</Link>
            <Link to="/settings/profile">{t('nav.account')}</Link>
            {(role === 'teacher' || role === 'admin') && (
              <Link to="/teacher">{t('nav.teacher')}</Link>
            )}
            {role === 'admin' && <Link to="/admin">{t('nav.admin')}</Link>}
            {/* Site announcements. Signed-in only — there is nothing addressed
                to a visitor, so the bell simply does not exist for them. */}
            <AnnouncementsBell />
            <span className="who">{t('auth.logged_in_as', { name: user.name })}</span>
            <button type="button" onClick={handleLogout} className="link-button">
              {t('nav.logout')}
            </button>
          </>
        )}

        <LanguageSwitcher />
      </nav>
    </header>
  )
}
